import { addGlobal } from '../utils';
import { formFocus, formFocusFirstChild } from './focus';
import { Form } from './form';

addGlobal('form', {
  config: Form.config,
  fromSelector: Form.fromSelector,
  errorHandler: Form.errorHandler,
  closestTo: Form.closestTo,
  formFocus,
  formFocusFirstChild,
});
